export default __webpack_public_path__ + "static/media/transport-logistics.398d4f3f.jpg";